<template>
  <div id="insideRecommend">
    <van-tabs v-model="active" @change="tabChange">
      <van-tab
        :title="item.name"
        :name="item.key"
        v-for="item in tabList"
        :key="item.name"
      ></van-tab>
    </van-tabs>
    <div class="info_list">
      <div class="info_item" v-for="(info, i) in infoItemData" :key="i">
        <div class="item_title">{{ info.title }}</div>
        <div class="item_img_detail">
          <div class="item_img">
            <img :src="'/hrApi' + info.pushCoverImagePath" alt="" />
          </div>
          <div class="item_detail">
            <div
              class="detail_tag"
              :class="
                info.taskStatus == 0
                  ? 'detail_tag_unpublished'
                  : 'detail_tag_published'
              "
            >
              {{ info.taskStatus == 0 ? "未发布" : "已发布" }}
            </div>
            <div class="detail_name">发起人：{{ info.publishUserNameStr }}</div>
          </div>
        </div>
        <div class="item_time">时间：{{ info.createTime }}</div>
        <!-- 未发布 -->
        <div class="item_btn">
          <el-button
            v-if="info.taskStatus == 1"
            style="background: #4ea27c; color: #fff"
            @click="checkDetail(info)"
            >查看</el-button
          >
          <el-button
            v-if="info.taskStatus == 0"
            style="color: #4ea27c; border: 1px solid #4ea27c"
            @click="editInfo(info)"
            >编辑</el-button
          >
          <el-button v-if="info.taskStatus == 0" @click="deleteDetail(info)"
            >删除</el-button
          >
          <!-- <el-button @click="publishNews(info,1)"
            >发布</el-button
          >
          <el-button @click="publishNews(info,0)"
            >取消发布</el-button
          > -->
        </div>
      </div>
    </div>
    <div class="footerBtn">
      <van-button
        icon="add-o"
        type="info"
        size="small"
        style="width: 70%; background-color: #4ea27c"
        @click="addNotice"
        >新增获奖公告</van-button
      >
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
export default {
  name: "newsNotice",
  data() {
    return {
      tabList: [
        {
          key: "null",
          name: "全部"
        },
        {
          key: "0",
          name: "未发布"
        },
        {
          key: "1",
          name: "已发布"
        }
      ],
      active: "null",
      infoItemData: []
    };
  },
  mounted() {
    this.active = localStorage.getItem("isActive");
    localStorage.removeItem("isActive");
    if (sessionStorage.getItem("saveActive")) {
      this.active = sessionStorage.getItem("saveActive");
    }
    sessionStorage.removeItem('saveActive')
    this.initPageData(this.active);
  },
  methods: {
    // 切换tab
    tabChange(val) {
      this.active = val;
    },
    // 初始化数据
    initPageData(val) {
      this.loading = true;
      api
        .queryNewPageList({
          taskStatus: val
        })
        .then(res => {
          this.loading = false;
          if (res.code == 200) {
            this.infoItemData = res.data;
          }
        });
    },
    //编辑公告
    editInfo(info) {
      this.$router.replace("/mobile/medal/notice");
      localStorage.setItem("newsInfo", JSON.stringify(info));
      this.saveActive();
    },
    //新增公告
    addNotice() {
      this.$router.push("/mobile/medal/notice");
    },
    // 查看新闻详情
    checkDetail(info) {
      this.$router.push({
        path: "/mobile/medal/publishPage",
        query: {
          id: info.id
        }
      });
      this.saveActive();
    },
    // 删除
    deleteDetail(info) {
      this.$dialog
        .confirm({
          message: "您确定要删除该信息吗？"
        })
        .then(() => {
          api.deleteNews(info.id).then(res => {
          
            if (res.code === 200) {
              this.initPageData(this.active);
              this.$toast("删除公告成功");
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 发布/取消发布
    publishNews(info,taskStatus) {
      const json = {
        id: info.id,
        taskStatus
      };
      api.publishCancel(json).then(res => {
        if (res.code === 200) {
          const value=taskStatus==1?"发布":'取消发布'
          this.initPageData(this.active);
          this.$toast(value+'成功');
        }
      });
    },
    // 保存当前tab
    saveActive() {
      sessionStorage.setItem("saveActive", this.active);
    }
  },
  watch: {
    // 监听当前tab
    active(val) {
      this.initPageData(val);
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #insideRecommend {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #insideRecommend {
    width: 276px * $zoom;
  }
}
#insideRecommend {
  display: flex;
  flex-direction: column;
  height: 100vh;
  ::v-deep .van-tabs__nav {
    .van-tab {
      float: left;
      width: 135px;
      font-size: 32px;
      line-height: 66px;
      color: #969b9e;
      background-color: #f7f9fa;
    }
    .van-tab--active {
      font-weight: 800;
      color: #282b32;
    }
    .van-tabs__line {
      width: 48px;
      height: 8px;
      background: #4ea27c;
    }
  }
  .info_list {
    // height: calc(100vh - 550px);
    flex: 1;
    padding: 0 28px;
    overflow-y: scroll;
    /* 隐藏滚动条 */
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .info_item {
      width: 100%;
      // height: 498px;
      margin-top: 24px;
      padding: 30px;
      background: #ffffff;
      border-radius: 12px;
      &:last-child {
        margin-bottom: 20px;
      }
      .item_title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 600px;
        font-size: 32px;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: #282b32;
        line-height: 44px;
      }
      .item_img_detail {
        display: flex;
        .item_img {
          width: 164px;
          height: 172px;
          margin: 24px 20px 24px 0;
          background: #f7f9fa;
          border-radius: 8px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .item_detail {
          .detail_tag {
            width: 100px;
            height: 46px;
            margin: 48px 0 20px;
            border-radius: 8px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #ffffff;
            line-height: 46px;
            text-align: center;
          }
          .detail_tag_unpublished {
            background: #f77c3f;
          }
          .detail_tag_published {
            background: #66bb69;
          }
          .detail_tag_expire {
            background: #b5b5b5;
          }
          .detail_name {
            font-size: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #282b32;
            line-height: 42px;
          }
        }
      }
      .item_time {
        padding-bottom: 30px;
        border-bottom: 2px solid #f1f1f1;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #282b32;
        line-height: 42px;
      }
      .item_btn {
        display: flex;
        justify-content: flex-end;
        margin-top: 38px;
        .el-button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 112px;
          height: 50px;
          padding: 0 10px;
          margin-left: 30px;
          border-radius: 8px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }
  }
  .footerBtn {
    height: 120px;
    border: 2px solid #fff;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    ::v-deep(.van-button--small) {
      height: 88px;
      border-radius: 16px;
      font-size: 29px;
      border: 0;
      .van-button__text {
        margin-left: 15px;
      }
      .van-button__icon {
        font-weight: 600;
        font-size: 38px;
      }
    }
  }
}
</style>
